<template>
    <div class="main-cover">
        <div class="content-wrapper">
            <div class="content">
                <ContentComponentItem
                    v-for="(component, key) in data.content"
                    :key="key"
                    :background="'BLUE'"
                    :data="component"
                />
            </div>
        </div>

        <div class="main-cover-image">
            <CmsImage
                v-if="data.mainCoverImage"
                :data="data.mainCoverImage"
                class="picture desktop"
                is-eager
                fit="cover"
            />

            <CmsImage
                v-if="data.mobileBackgroundImage"
                :data="data.mobileBackgroundImage"
                class="picture mobile"
                fit="cover"
                is-eager
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ComponentMainCoverFragment } from '@/graphql/api'

import ContentComponentItem from '@/components/cms/component/ContentComponentItem.vue'
import CmsImage from '@/components/cms/CmsImage.vue'

defineProps<{
    data: ComponentMainCoverFragment
}>()
</script>

<style lang="scss" scoped>
.main-cover {
    width: 100%;
    height: 520px;
    position: relative;

    @include min-width(1024) {
        height: 700px;
        max-height: 70vh;
    }

    .main-cover-image {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;

        .picture {
            width: 100%;
            height: 100%;
            object-fit: cover;

            &.desktop {
                display: none;

                @include min-width(768) {
                    display: block;
                }
            }

            &.mobile {
                display: block;

                @include min-width(768) {
                    display: none;
                }
            }
        }
    }

    .content-wrapper {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        background: linear-gradient(180deg, rgba($black, 0), rgba($black, 0.5));

        .content {
            width: 100%;
            padding: 60px 20px;

            :deep(.text) {
                max-width: 360px;
            }
        }
    }
}
</style>
